// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__64G9J","list":"BalanceDue_list__3W0ih","listRow":"BalanceDue_listRow__1_P9h","total":"BalanceDue_total__1Tgvn"};